import React from 'react';
import { Card, Col } from 'react-bootstrap';

const SummaryCard = ({ title, count }) => {
  return (
    <Col md={4} className="mb-3">
      <Card className="p-2 shadow-sm">
        <Card.Body>
          <Card.Title>{title}</Card.Title>
          <Card.Text>{count}</Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default SummaryCard;
